import { render, staticRenderFns } from "./AlarmParam.vue?vue&type=template&id=a06ef6e6&scoped=true&"
import script from "./AlarmParam.vue?vue&type=script&lang=js&"
export * from "./AlarmParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06ef6e6",
  null
  
)

export default component.exports